import { actionTypes } from './actions';
import { initialState } from './initial';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };

    case actionTypes.GET_STATISTIC_PROVIDER:
      return {
        ...state,
        statisticProvider: { ...action.payload },
        actionProcessing: false,
      };

    case actionTypes.GET_PAYMENT_HISTORY:
      return {
        ...state,
        paymentHistory: action.payload,
        paymentHistoryTotals: {
          ...state.paymentHistoryTotals,
          lastCalculateTime: action.payload.details.lastCalculateTime,
        },
        actionProcessing: false,
      };

    case actionTypes.GET_PAYMENT_HISTORY_TOTAL:
      return {
        ...state,
        paymentHistoryTotals: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_USER_STATISTICS:
      return {
        ...state,
        statisticPlayer: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_SLOTS_HISTORY:
      return {
        ...state,
        slotsHistory: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_BETS_HISTORY:
      return {
        ...state,
        betsHistory: action.payload,
        actionProcessing: false,
      };

    case actionTypes.GET_PLAYER_DEPOSITS:
      return {
        ...state,
        playerDeposits: {
          data: action.payload.items,
          count: action.payload.count,
          cbu: state.playerDeposits.cbu,
        },
        actionProcessing: false,
      };

    case actionTypes.GET_CBU:
      return {
        ...state,
        playerDeposits: {
          data: state.playerDeposits.data,
          count: state.playerDeposits.count,
          cbu: action.payload,
        },
        actionProcessing: false,
      };

    case actionTypes.GET_REQUEST_HISTORY:
      return {
        ...state,
        requestHistory: {
          data: action.payload.data,
          count: action.payload.count,
        },
      };

    case actionTypes.GET_CASHBACK_HISTORY:
      return {
        ...state,
        cashbackHistory: action.payload,
      };

    default:
      return { ...state };
  }
}
